export default defineNuxtRouteMiddleware((to, from) => {
  const isBiennaleRoute = to.path.match(/\/(biennale|bienale)/);
  const biennaleLangCookie = useCookie<boolean | null>('biennale_lang_it');

  if (!isBiennaleRoute) {
    if (to.query.lang === 'it') {
      const newQuery = { ...to.query };
      delete newQuery.lang;

      return navigateTo({
        path: to.path,
        query: newQuery,
      });
    }
    return;
  }

  if (biennaleLangCookie.value === true && to.query.lang !== 'it') {
    return navigateTo({
      path: to.path,
      query: { ...to.query, lang: 'it' },
    });
  }
});
